import { render, staticRenderFns } from "./OccurrenceFile.vue?vue&type=template&id=98da3ff0&"
import script from "./OccurrenceFile.vue?vue&type=script&lang=js&"
export * from "./OccurrenceFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports